// extracted by mini-css-extract-plugin
module.exports = {"table":"PoliciesModal_table__2TO01","policieModal":"PoliciesModal_policieModal__1F6-y"};